import { render, staticRenderFns } from "./EntityHome.vue?vue&type=template&id=ee7786dc"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee7786dc')) {
      api.createRecord('ee7786dc', component.options)
    } else {
      api.reload('ee7786dc', component.options)
    }
    module.hot.accept("./EntityHome.vue?vue&type=template&id=ee7786dc", function () {
      api.rerender('ee7786dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntityHome.vue"
export default component.exports